import {Cloneable} from "../../../model/common.model";

export class MemoContentWorkShift extends Cloneable{

  applicantEmployeeCode: string;
  providerEmployeeCode: string;
  requesterEmployeeCode: string;
  requesterName: string;
  scheduleId: number;
  unitId: string;
  unitLabel: string;
  jobId: string;
  jobLabel: string;
  eventDate: Date;

  divisionId: string;
  divisionLabel: string;

  // WONT WORK.... If you have 12:45 for example. Will work only for :30 or :00

  // interval: number;
  // intervalOverNight: number;
  dateIso:boolean;
  startHour: Date;
  endHour: Date;


  note:string;
}
